import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Container } from '~/styles/pagesStyle';

import Menu from '~/components/Menu';
import Card from './Card';

import api from '~/services/api';
import store from '~/store/Store';
import { handleDeletePage } from '../PaginasServices';
import Footer from '~/components/Footer';

function PaginaLista() {
  const [modulos, setModulos] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(false);
  const [moduloNome, setModuloNome] = useState('');

  useEffect(() => {
    setLoading(true);
    async function getModulesData() {
      await api
        .get('/Modulo/GetPaginado/Page/1/Length/100')
        .then((response) => {
          setModulos(response.data.registros);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao buscar dados dos módulos, recarregue a página');
          setLoading(false);
        });
    }
    getModulesData();
  }, []);

  async function handleGetPagesData(e) {
    e.preventDefault();
    setLoading(true);

    const modulo = store.getState().Paginas.idModuloPagina;

    if (modulo === undefined) {
      toast.error('Escolha um módulo');
      setLoading(false);
      return;
    }
    setSelected(true);

    await api.get(`Modulo/${modulo}`).then((response) => {
      setModuloNome(response.data.nome);
      setLoading(false);
    });
  }

  async function handleDelete() {
    setLoading(true);
    await handleDeletePage();
    setLoading(false);
  }

  return (
    <Container>
      <Footer />
      <Menu />
      <Card
        modulos={modulos}
        handleGetPagesData={handleGetPagesData}
        loading={loading}
        selected={selected}
        moduloNome={moduloNome}
        handleDelete={handleDelete}
      />
    </Container>
  );
}

export default PaginaLista;
